import { createItemsData } from '../utils/request-utils'
import { Service } from './base-service'
import { HALApiService } from './hal-api.service'

export const servicePointService = new Service('/delivery-services/service-points', HALApiService, createItemsData)
